import * as React from 'react';
import { useState, useEffect } from 'react';
import { getUser, UserData } from '../pages/getUserDB';
import { useTheme } from '@mui/material/styles'; // Já está aqui, perfeito!
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CheckoutModal from '../pages/payment/CheckoutModal';
import { useNavigate } from 'react-router-dom';

const tiers = [
  {
    title: 'Flex',
    subtitle: 'Ideal para quem quer testar e ver os resultados imediatos, sem compromisso de longo prazo.',
    price: '189,90',
    description: [
      'Assistente personalizado',
      'Integração com Agendas',
      'Suporte VIP e tutoriais completos',
      'Conversas ILIMITADAS',
      'Banco de dados',
    ],
  },
  {
    title: 'Smart',
    subtitle: 'Planeje seu semestre com inteligência, garanta a automação do seu atendimento e economize no processo.',
    subheader: 'Recommended',
    price: '949,90',
    description: [
      'Você ganha 1 mês de graça',
      'Assistente personalizado',
      'Integração com Agendas',
      'Suporte VIP e tutoriais completos',
      'Conversas ILIMITADAS',
      'Banco de dados',
    ],
  },
  {
    title: 'Prime',
    subtitle: 'Garanta 12 meses de tranquilidade e receba nosso maior desconto como parceiro estratégico.',
    price: '1709,90',
    description: [
      'A MELHOR ECONOMIA: Ganhe 3 meses GRÁTIS!',
      'Assistente personalizado',
      'Integração com Agendas',
      'Suporte VIP e tutoriais completos',
      'Conversas ILIMITADAS',
      'Banco de dados',
    ],
  },
];

interface Props {
  isPaymentPage?: boolean
}

export default function Pricing({ isPaymentPage }: Props) {
  const [paymentStatus, setPaymentStatus] = useState<string | null>(null);
  const theme = useTheme();
  const [userDB, setUserDB] = useState<UserData>();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [plan, setPlan] = useState('Flex');
  const [price, setPrice] = useState(0.01);
  const navigate = useNavigate();
  const item = {
    id: '1',
    title: 'Nextalk',
    description: 'Nextalk - CABANALINK',
    category_id: 'chatbot',
    quantity: 1,
    currency_id: 'BRL',
    unit_price: price,
  };

  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      setUserDB(data);
      setLoading(false);
    }
    dataUser();
  }, [paymentStatus]);

  const handlePayClick = (choicedPlan: string) => {
    if (!isPaymentPage) {
      navigate('/signin');
      return;
    }
    setPlan(choicedPlan);
    setShowModal(true);

    if (choicedPlan === 'Flex') {
      setPrice(189.90);
    } else if (choicedPlan === 'Smart') {
      setPrice(949.90);
    } else if (choicedPlan === 'Prime') {
      setPrice(1709.90);
    }
  };

  return (
    <Container
      id="pricing"
      sx={{
        pt: isPaymentPage ? 0 : { xs: 4, sm: 12 },
        pb: isPaymentPage ? 0 : { xs: 8, sm: 16 },
        pl: { xs: 2, sm: 2 },
        pr: { xs: 2, sm: 2 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '100%' },
          textAlign: { sm: 'left', md: 'center' },
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
        >
          Planos
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Escolha o plano perfeito para ofereçer ao seu cliente
          uma experiência de atendimento ágil, <br />
          automática e humanizada contando com nossa inteligência artificial.
        </Typography>
      </Box>
      <Grid
        container
        spacing={3}
        sx={{ alignItems: 'center', justifyContent: 'center', width: '100%' }}
      >
        {tiers.map((tier) => (
          <Grid
            size={{ xs: 12, sm: tier.title === 'Prime' ? 12 : 6, md: 4 }}
            key={tier.title}
          >
            <Card
              sx={[
                {
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                  border: 'none', // Sem borda para nenhum card
                  // Estilo padrão para os cards Mensal e Anual
                  backgroundColor: theme.palette.mode === 'dark' ? 'grey.900' : 'grey.50',
                  boxShadow: '0 8px 12px hsla(0, 0%, 0%, 0.1)',
                },
                // ALTERAÇÃO: Lógica de inversão de tema para o card Smart
                tier.title === 'Smart' && ((theme) => (
                  theme.palette.mode === 'dark'
                    ? { // MODO DARK: Fundo bege, texto escuro
                      backgroundColor: '#fffcf2 !important',
                      boxShadow: '0 8px 24px hsla(0, 0%, 0%, 0.4)',
                    }
                    : { // MODO LIGHT: Fundo escuro, texto bege
                      backgroundColor: 'grey.900',
                      boxShadow: '0 8px 24px hsla(0, 0%, 0%, 0.4)',
                    }
                )),
              ]}
            >
              <CardContent>
                <Box
                  sx={[
                    {
                      mb: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 2,
                    },
                    // Lógica de inversão para o texto do título
                    tier.title === 'Smart' && ((theme) => (
                      theme.palette.mode === 'dark'
                        ? { color: 'grey.900' } // Modo dark: texto cinza
                        : { color: 'grey.50' } // Modo light: texto bege
                    )),
                  ]}
                >
                  <Typography component="h3" variant="h6">
                    {tier.title}
                  </Typography>
                  {tier.title === 'Smart' && (
                    <Chip icon={<AutoAwesomeIcon />} label='Recomendado' color="primary" />
                  )}
                </Box>
                <Box sx={[
                  { mb: 2 },
                  tier.title === 'Smart' && ((theme) => (
                      theme.palette.mode === 'dark'
                        ? { color: 'grey.900' } // Modo dark: texto cinza
                        : { color: 'grey.50' } // Modo light: texto bege
                    )),
                 ]}>
                  <Typography variant="body1">
                    {tier.subtitle}
                  </Typography>
                </Box>
                <Box
                  sx={[
                    { display: 'flex', alignItems: 'baseline' },
                    // Lógica de inversão para o texto do preço
                    tier.title === 'Smart' && ((theme) => (
                      theme.palette.mode === 'dark'
                        ? { color: 'grey.900' }
                        : { color: 'grey.50' }
                    )),
                  ]}
                >
                  <Typography component="h3" variant="h2">
                    R${tier.price}
                  </Typography>
                  {tier.title !== 'Flex' && (
                    <Typography component="h3" variant="h6">
                      até {tier.title === 'Smart' ? '6x' : '12x'}
                      <span style={{ fontSize: '0.7em' }}>sem juros</span>
                    </Typography>
                  )}
                </Box>
                <Divider sx={{ my: 2, opacity: 0.8, borderColor: tier.title === 'Smart' && theme.palette.mode === 'dark' ? 'grey.300' : 'divider' }} />
                {tier.description.map((line) => (
                  <Box
                    key={line}
                    sx={{ py: 1, display: 'flex', gap: 1.5, alignItems: 'center' }}
                  >
                    <CheckCircleRoundedIcon sx={{ width: 20, color: 'primary.main' }} />
                    <Typography
                      variant="subtitle2"
                      component={'span'}
                      sx={[
                        // Lógica de inversão para o texto da descrição
                        tier.title === 'Smart' && ((theme) => (
                          theme.palette.mode === 'dark'
                            ? { color: 'grey.900' }
                            : { color: 'grey.50' }
                        )),
                      ]}
                    >
                      {line}
                    </Typography>
                  </Box>
                ))}
              </CardContent>
              <CardActions>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handlePayClick(tier.title)}
                  // Lógica de inversão para todos os botões, criando contraste
                  sx={(theme) => {
                    const isSmart = tier.title === 'Smart';
                    const isDarkMode = theme.palette.mode === 'dark';

                    if ((isSmart && isDarkMode) || (!isSmart && !isDarkMode)) {
                      // Caso 1: Smart/Dark OU Outros/Light -> Botão escuro
                      return {
                        background: '#0E0E0E !important',
                        color: '#fffcf2 !important',
                        '&:hover': { background: '#242424ff !important' },
                      };
                    } else {
                      // Caso 2: Semestral/Light OU Outros/Dark -> Botão claro
                      return {
                        background: '#fffcf2 !important',
                        color: '#0E0E0E !important',
                        '&:hover': { background: '#fffcf2 !important' },
                      };
                    }
                  }}
                >
                  Assinar {tier.title}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
      {showModal && <CheckoutModal
        onClose={() => setShowModal(false)}
        item={item}
        plan={plan}
      />}
    </Container>
  );
}